import { IBaseResponse } from 'utils/types';

import { ISharedLink } from './types';

export const normalizeShortLink = (
  data: IBaseResponse<string>,
): IBaseResponse<string> => {
  return {
    result: data.result || '',
  };
};

export const normalizeSharedLink = (data: IBaseResponse<ISharedLink>): ISharedLink => {
  return {
    sharedLink: data.result?.sharedLink || '',
  };
};
